import { FormSwitch, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ContactBankAccountSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext } from "react-hook-form";

export function ContactBankAccountForm() {
	/** Context */
	const methods = useFormContext<ContactBankAccountSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<TextInput
				control={methods.control}
				name="iban"
				label={t("organization.iban")}
				placeholder="DE89 3704 0044 0532 0130 00"
				isRequired
				data-cy="contact-bank-account-iban-input"
			/>
			<TextInput
				control={methods.control}
				name="bic"
				label={t("organization.bic")}
				placeholder="COBADEFFXXX"
				isRequired={false}
				data-cy="contact-bank-account-bic-input"
			/>
			<TextInput
				control={methods.control}
				name="accountHolder"
				label={t("organization.bank_account_holder")}
				isRequired={false}
				data-cy="contact-bank-account-holder-input"
			/>
			<TextInput
				control={methods.control}
				name="bankName"
				label={t("contacts.bank_accounts.bank_name")}
				isRequired={false}
				data-cy="contact-bank-account-bank-name-input"
			/>
			<FormSwitch
				control={methods.control}
				name="isDefault"
				data-cy="contact-bank-account-default-switch"
			>
				{t("contacts.bank_accounts.is_default")}
			</FormSwitch>
		</React.Fragment>
	);
}
